module.exports = __webpack_public_path__ + "img/image_questionary.5cbdd617.png";